export default __webpack_public_path__ + "a969f00a6b247a44539c54263c76eeb7.png";